import React from 'react';
import { useState } from 'react';
import { Button, Typography, InputText } from '@jota-ds/lib-react';
import axios from 'axios';

export default function Four() {
    const [response, setResponse] = useState();
    const [inputEmail, setInputEmail] = useState();
    const [errorEmailValid, setErrorEmailValid] = useState(false);
    const [disabledButton, setDisabledButton] = useState(true);

    React.useEffect(() => {
        document.getElementById('jota-input').required = true
    }, [])

    function validateEmail(email) {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    const send = (e) => {
        e.preventDefault();

        if (validateEmail(inputEmail)) {

        let data = JSON.stringify({
            email: inputEmail,
        });

        let config = {
            method: "post",
            url: "https://gpczvxgk2g.execute-api.us-east-2.amazonaws.com/Golden-Tickets-Generator-Mailchimp-Subscriber",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(config)
            .then((response) => {
                setResponse('success')
            })
            .catch((error) => {
                setResponse('error')
            });
        } else {
            setErrorEmailValid(true)
        }
    };

    const handleChange = (input) => {
        setInputEmail(input);
        if (validateEmail(input)) {
            setDisabledButton(false);
        } else {
            setDisabledButton(true);
        }
    }

    return (
        <section className="four pt-large pb-large d-flex align-items-center">
            <img className="left d-none d-md-block" alt="" src="/assets/union4.svg" />
            <img className="bottom d-none d-md-block" alt="" src="/assets/vector4.svg" />

            <div className="row justify-content-center card-body">
                <div className="col-md-4">
                    <div className="mb-5 text-center">
                        <img className="img-fluid" alt="" src="/assets/camada1.svg" />
                    </div>

                    <div className="title mb-4">
                        <Typography component="heading" size="large">
                            Você já fez um dos
                            nossos cursos ?
                        </Typography>
                    </div>

                    <div className="mb-5 muted fw-500">
                        <Typography component="heading" size="small">
                            Resgate agora seus bilhetes!
                        </Typography>
                    </div>

                    <form id="form" action="" onSubmit={send}>
                        <div className="d-grid gap-2 mb-1">
                            <InputText
                                label="E-mail"
                                placeholder="Digite seu e-mail aqui..."
                                helperText="Insira um e-mail válido!"
                                error={errorEmailValid}
                                handleChange={handleChange}
                            />
                        </div>
                        <div className="muted font-14">
                            <Typography component="paragraph" size="small">
                                Digite o mesmo e-mail usado para adquirir o curso :)
                            </Typography>
                        </div>

                        <div className="btn-enviar d-flex justify-content-center mb-3 send">
                            <Button
                                label="Enviar"
                                type="primary"
                                disabled={disabledButton}
                                handleClick={() => document.getElementById('form').submit}
                            />
                        </div>
                    </form>
                </div>
            </div>
            {(response === 'success') &&
                <div data-aos="slide-right" data-aos-once="true" className="success d-flex flex-column justify-content-center">
                    <div className="mb-3">
                        <Typography component="heading" size="x-large">Boooa!</Typography>
                    </div>
                    <div className="mb-5 paragraph">
                        <Typography component="heading" size="x-small">
                            Deu tudo certo. Já já chega no seu inbox. <br/>
                            Deve demorar uns minutinhos, tá?
                        </Typography>
                    </div>
                    <div className="d-flex justify-content-center">
                        <Button
                            label="Voltar ao início"
                            type="primary"
                            handleClick={() => window.location.replace('/')}
                        />
                    </div>
                </div>
            }
            {(response === 'error') &&
                <div data-aos="slide-right" data-aos-once="true" className="error d-flex flex-column justify-content-center">
                    <div className="mb-3">
                        <Typography component="heading" size="x-large">Ops!</Typography>
                    </div>
                    <div className="mb-5">
                        <Typography component="heading" size="x-small">
                            Parece que alguma coisa deu <br/>
                            errado por aqui.
                        </Typography>
                    </div>

                    <div className="mb-5 d-flex justify-content-center">
                        <Button
                            label="Tentar novamente"
                            type="primary"
                            handleClick={() => setResponse('form')}
                        />
                    </div>
                    <div className="mt-5 pt-5 d-flex justify-content-center">
                        <img alt="" src="/assets/vector1.svg" />
                    </div>
                </div>
            }
        </section>
    )
}